import {createContext, useContext} from 'react';

/**
 * @typedef {Object} CfPreviewContextValue
 * @property {string} space
 * @property {string} environment
 * @property {string|null} contentType
 * @property {boolean} xrayModeEnabled
 * @property {string|null} fieldId
 */

export const CfPreviewContext = createContext(/** @var {CfPreviewContextValue | null} */ null);

/**
 * @param {boolean} enabled
 * @param {string} locale
 * @param {ReactNode} children
 * @returns {JSX.Element}
 */
export function CfPreview({enabled, space, environment, children, xrayModeEnabled}) {
    if (!enabled) {
        return <>{children}</>;
    }
    const locale = document.documentElement.lang || 'default';

    return (
        <CfPreviewContext.Provider
            value={{locale, space, environment, contentType: null, fieldId: null, xrayModeEnabled}}
        >
            {children}
        </CfPreviewContext.Provider>
    );
}

/**
 * @param {string} entryId
 * @param {string} contentType
 * @param {ReactNode} children
 * @returns {JSX.Element}
 */
export function CfEntry({entryId, contentType, children}) {
    const previewContext = useContext(CfPreviewContext);
    if (!previewContext) {
        return <>{children}</>;
    }
    const value = {
        ...previewContext,
        entryId,
        contentType,
    };
    return <CfPreviewContext.Provider value={value}>{children}</CfPreviewContext.Provider>;
}
